export default "__VITE_ASSET__KXO_ORay__"